<script setup lang="ts">
import type { CreateLinkConfig, ListableContent } from "~/utils/types";

withDefaults(
  defineProps<{
    content: ListableContent;
    showParent?: boolean;
    showParents?: boolean;
    showChildren?: boolean;
    compact?: boolean;
    showAreas?: boolean;
    linkConfig?: CreateLinkConfig;
    calendar?: boolean;
    highlight?: boolean;
  }>(),
  {
    showParent: false,
    showChildren: false,
    compact: false,
    showAreas: true,
    calendar: false,
    highlight: false,
    linkConfig: undefined,
  }
);
</script>

<template>
  <template v-if="'contentable_type' in content">
    <FrontContentItemsNotizia
      v-if="content.contentable_type === 'notizia'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsScadenza
      v-else-if="content.contentable_type === 'scadenza' && !calendar"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsScadenzaCalendar
      v-else-if="content.contentable_type === 'scadenza' && calendar"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsPratica
      v-else-if="content.contentable_type === 'pratica'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsModelloCard
      v-else-if="content.contentable_type === 'modello'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsNorma
      v-else-if="content.contentable_type === 'norma'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsArticoloNorma
      v-else-if="content.contentable_type === 'articolo-norma'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsLink
      v-else-if="content.contentable_type === 'link'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsArticoloRivista
      v-else-if="content.contentable_type === 'articolo-rivista'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsQuesito
      v-else-if="content.contentable_type === 'quesito'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsScadenzarioElettorale
      v-else-if="content.contentable_type === 'scadenzario-elettorale'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsScadenzaElettorale
      v-else-if="content.contentable_type === 'scadenza-elettorale'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsPostIt
      v-else-if="content.contentable_type === 'postit'"
      v-bind="$props"
      :content="content"
    />
    <FrontContentItemsBaseContent v-else v-bind="$props" :content="content" />
  </template>
  <template v-else-if="'publication_frequency' in content">
    <FrontContentItemsRivista v-bind="$props" :content="content" />
  </template>
  <template v-else-if="'rivista_id' in content">
    <FrontContentItemsNumeroRivista v-bind="$props" :content="content" />
  </template>
  <template v-else-if="'question' in content">
    <FrontContentItemsQuesitoInviato v-bind="$props" :content="content" />
  </template>
  <template v-else-if="'number' in content">
    <FrontContentItemsMemoweb v-bind="$props" :content="content" />
  </template>
  <template v-else-if="'exclude_first_login_users' in content">
    <FrontContentItemsNotice v-bind="$props" :content="content" />
  </template>
</template>
